var map = {
	"./about-1.jpg": 2657,
	"./about-2.jpg": 8602,
	"./about-3.jpg": 8353,
	"./about-bg.mp4": 5809,
	"./about.jpg": 1016,
	"./about/icon-1.png": 8566,
	"./about/icon-2.png": 8351,
	"./about/icon-3.png": 7155,
	"./about/icon-4.png": 8418,
	"./carousel-1.jpg": 3970,
	"./carousel-2.jpg": 5647,
	"./carousel-3.jpg": 9893,
	"./carousel-4.jpg": 8646,
	"./contact-bg.mp4": 9844,
	"./features.mp4": 7462,
	"./icon/ai-1.png": 8191,
	"./icon/ai-2.png": 4713,
	"./icon/ai-3.png": 3068,
	"./icon/icon-1.png": 9489,
	"./icon/icon-10.png": 973,
	"./icon/icon-11.png": 8639,
	"./icon/icon-12.png": 2218,
	"./icon/icon-2.png": 1220,
	"./icon/icon-3.png": 4898,
	"./icon/icon-4.png": 9161,
	"./icon/icon-5.png": 4029,
	"./icon/icon-6.png": 8431,
	"./icon/icon-7.png": 6932,
	"./icon/icon-8.png": 1346,
	"./icon/icon-9.png": 9885,
	"./icon/soft-2.png": 4154,
	"./icon/soft-3.png": 3461,
	"./icon/soft-4.png": 6070,
	"./icon/soft-5.png": 6093,
	"./icon/soft-6.png": 7174,
	"./icon/soft-7.png": 5862,
	"./logo.png": 5080,
	"./product/img-1.png": 5420,
	"./product/img-2.png": 8219,
	"./product/img-3.png": 7461,
	"./product/img-4.png": 4054,
	"./product/img-5.png": 5167,
	"./project-1.jpg": 5595,
	"./project-2.jpg": 1465,
	"./project-3.jpg": 8994,
	"./project-4.jpg": 2379,
	"./team-1.jpg": 6101,
	"./team-2.jpg": 1209,
	"./team-3.jpg": 6781,
	"./team-4.jpg": 4702,
	"./testimonial-1.jpg": 1600,
	"./testimonial-2.jpg": 1715,
	"./testimonial-3.jpg": 866,
	"./testimonial-4.jpg": 9648
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;